var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockicon = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3.5a.5.5 0 00-1 0V4H4a2 2 0 00-2 2v7a2 2 0 002 2h10a2 2 0 002-2V6a2 2 0 00-2-2h-1v-.5a.5.5 0 00-1 0V4H6v-.5zm6 2V5H6v.5a.5.5 0 01-1 0V5H4a1 1 0 00-1 1v1h12V6a1 1 0 00-1-1h-1v.5a.5.5 0 01-1 0zM15 8H3v5a1 1 0 001 1h10a1 1 0 001-1V8z"
  })));
});
export default SvgClockicon;